export default __webpack_public_path__ + "static/media/spotify.93e5215d.svg";